/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './network-settings.scss';

/* eslint-disable import/no-unresolved, import/default */

import networkSettingsFieldsetTemplate from './network-settings-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function NetworkSettingsDirective($compile, $templateCache, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(networkSettingsFieldsetTemplate);
        element.html(template);

        scope.types = types;

        scope.$watch('networkSettings', () => {
           if (scope.networkSettings) {
               if (scope.networkSettings.cfList == null) {
                   scope.networkSettings.cfList = [];
               }
               if (!scope.networkSettings.chMaskCtrlDataList || !scope.networkSettings.chMaskCtrlDataList.length) {
                   scope.chMaskOption = types.chMaskOptions.notDefined.value;
               } else {
                   if (angular.equals(scope.networkSettings.chMaskCtrlDataList, types.channelMaskOptionsData.channels8)) {
                       scope.chMaskOption = types.chMaskOptions.channels8.value;
                   } else if (angular.equals(scope.networkSettings.chMaskCtrlDataList, types.channelMaskOptionsData.channels64)) {
                       scope.chMaskOption = types.chMaskOptions.channels64.value;
                   } else {
                       scope.chMaskOption = types.chMaskOptions.custom.value;
                   }
               }
           }
        });

        scope.validateCf = function($chip) {
            if (!$chip) return;
            var freq = Number($chip);
            freq = Math.floor(freq * 100) / 100;
            if (freq < 100 || freq > 1670) {
                return null;
            }
            return freq;
        };

        scope.chMaskOptionChanged = function() {
            if (scope.chMaskOption != types.chMaskOptions.custom.value) {
                scope.networkSettings.chMaskCtrlDataList = angular.copy(types.channelMaskOptionsData[scope.chMaskOption]);
                scope.theForm.$setDirty();
            }
        };

        scope.removeChMask = function(index) {
            if (index > -1) {
                scope.networkSettings.chMaskCtrlDataList.splice(index, 1);
                scope.theForm.$setDirty();
            }
        }

        scope.addChMask = function () {
            if (!scope.networkSettings.chMaskCtrlDataList) {
                scope.networkSettings.chMaskCtrlDataList = [];
            }
            scope.networkSettings.chMaskCtrlDataList.push(
                {
                    chMask: '',
                    chMaskCntl: ''
                }
            );
            scope.theForm.$setDirty();
        }

        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            networkSettings: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/network-settings/network-settings.directive.js